import PropTypes from "prop-types";
import styles from "./styles.module.css";

const ModalHeader = ({ title }) =>  <div className={styles.modalHeader}>{title}</div>

ModalHeader.propTypes = {
  title: PropTypes.string.isRequired,
};

export default ModalHeader;
